import { UnauthorizedError } from '@/api/errors';
import type { DoorsaleEvent } from '@/types';
import type { DoorsaleEventDTO } from '@/utils/dtoTransformers/doorsaleEventDTO';
import { mapDtosToDoorsaleEvents } from '@/utils/dtoTransformers/doorsaleEventDTO';

export async function fetchDoorsaleEvents(): Promise<{ events: DoorsaleEvent[] }> {
	const response = await fetch('/of2/json/doorsale/events', {
		credentials: 'include',
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
		},
	});

	if (response.status === 401 || response.status === 403) {
		throw new UnauthorizedError();
	}

	if (!response.ok) {
		throw new Error(`fetchDoorsaleEvents failed: ${response.status}`);
	}

	const data = await response.json() as { events: DoorsaleEventDTO[] };
	console.log("fetchDoorsaleEvents returned", data);
	
	return { events: mapDtosToDoorsaleEvents(data.events) };
}
